<template>
  <div class="container" :style="this.getContainerStyle()">
    <p :style="this.getTextStyle()">{{letters}}</p>
  </div>
</template>

<script>
import Helpers from "../../utils/helpers/functions";

export default {
  name: "PersonPortrait",
  props: {
    firstName: String,
    lastName: String,
    scale: Number
  },

  computed: {
    letters() {
      return this.firstName[0] + this.lastName[0];
    }
  },
  methods: {
    getHue() {
      return Helpers.Color.getHue(`${this.firstName}${this.lastName}`);
    },
    getContainerStyle() {
      let s = this.scale == null ? 1 : this.scale;
      return `background-color: ${Helpers.Color.getHSLSecondary(
        this.getHue()
      )}; padding: 10px; transform: scale(${s}, ${s});`;
    },
    getTextStyle() {
      return `color: ${Helpers.Color.getHSLPrimary(this.getHue())}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

p {
  color: white;
  font-size: 1.4em;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 600;
}

.container {
  text-align: center;
  border-radius: $border-radius; // : 50%;
  width: 50px;
  height: 50px;
  max-width: 50px;
  max-height: 50px;
}
</style>
